import React from 'react';

import  Baglessday2024  from 'views/Baglessday2024';
const BlogNewsroomPage = () => {

return <Baglessday2024/>
};

export default BlogNewsroomPage;